/* ============================================================
   KasaMoon — Marque dorée automatique
   Dore le « M » de chaque « KasaMoon » écrit sur le site,
   via la classe .km-gold définie dans kasamoon-brand.css.
   Aucune maintenance : écrire « KasaMoon » suffit.
   ============================================================ */
(function () {
  'use strict';
  var BRAND = 'KasaMoon';
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TITLE: 1, OPTION: 1, SELECT: 1 };

  function goldify(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf(BRAND) === -1) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (SKIP_TAGS[parent.tagName]) return NodeFilter.FILTER_REJECT;
        if (parent.closest('svg, [contenteditable="true"], .km-brandmark')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var i = 0; i < nodes.length; i++) wrap(nodes[i]);
  }

  function wrap(textNode) {
    var parts = textNode.nodeValue.split(BRAND);
    if (parts.length < 2) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < parts.length; i++) {
      if (i > 0) frag.appendChild(brandmark());
      if (parts[i]) frag.appendChild(document.createTextNode(parts[i]));
    }
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function brandmark() {
    var span = document.createElement('span');
    span.className = 'km-brandmark';
    span.appendChild(document.createTextNode('Kasa'));
    var m = document.createElement('span');
    m.className = 'km-gold';
    m.appendChild(document.createTextNode('M'));
    span.appendChild(m);
    span.appendChild(document.createTextNode('oon'));
    return span;
  }

  function run() {
    goldify(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
